import { isSupportedCountry } from '@forto-dev/phoenix-ui-core'

import { BookingDTO } from '@/clients/booking'
import { getFullAddress, Timeline, TimelineMilestoneData } from '@/features/shipments'

import { getDeliveryAddress, getDestinationPort, getOriginPort, getPickupAddress } from './waypoints'

export type GetBookingTimelineArgs = Pick<
  BookingDTO,
  | 'waypoints'
  | 'cargoReadyAt'
  | 'departureAt'
  | 'arrivalAt'
  | 'deliveryDueAt'
  | 'originPortName'
  | 'destinationPortName'
>
export const getBookingTimeline = ({
  waypoints,
  cargoReadyAt,
  departureAt,
  arrivalAt,
  deliveryDueAt,
  originPortName,
  destinationPortName,
}: GetBookingTimelineArgs): Timeline => {
  const pickupAddress = getPickupAddress(waypoints)
  const deliveryAddress = getDeliveryAddress(waypoints)
  const originPort = getOriginPort(waypoints)
  const destinationPort = getDestinationPort(waypoints)

  const originCountryCode = pickupAddress?.place?.countryCode?.toUpperCase()
  const destinationCountryCode = deliveryAddress?.place?.countryCode?.toUpperCase()

  return {
    origin: {
      ...defaultTimelineMilestone,
      date: new Date(cargoReadyAt),
      location: pickupAddress ? getFullAddress(pickupAddress.place) : '',
      flag: originCountryCode && isSupportedCountry(originCountryCode) ? originCountryCode : undefined,
    },
    departure: {
      ...defaultTimelineMilestone,
      date: departureAt ? new Date(departureAt) : undefined,
      location: `${originPortName} (${originPort}) `,
    },
    arrival: {
      ...defaultTimelineMilestone,
      date: arrivalAt ? new Date(arrivalAt) : undefined,
      location: `${destinationPortName} (${destinationPort})`,
    },
    delivery: {
      ...defaultTimelineMilestone,
      date: deliveryDueAt ? new Date(deliveryDueAt) : undefined,
      location: deliveryAddress ? getFullAddress(deliveryAddress.place) : '',
      flag: destinationCountryCode && isSupportedCountry(destinationCountryCode) ? destinationCountryCode : undefined,
    },
  }
}

const defaultTimelineMilestone: TimelineMilestoneData = {
  dateStatus: 'estimated',
  progress: 0,
  date: undefined,
  location: '—',
  outgoingConnections: [],
}
